/**
 * Человекочитаемые названия провайдеров мессенджеров.
 *
 * Общий источник правды для лейблов вкладок и карточки профиля диалога,
 * чтобы не дублировать соответствие provider → название в разных helper'ах.
 */
export const PROVIDER_LABELS: Record<string, string> = {
  telegram: 'Telegram',
  max: 'MAX',
  vk: 'VK',
};

/**
 * Лейбл провайдера в любом регистре (enum GraphQL — `TELEGRAM`) с фолбэком `'Канал'`
 * для неизвестного/отсутствующего значения.
 */
export function getProviderLabel(provider?: string): string {
  return (provider && PROVIDER_LABELS[provider.toLowerCase()]) || 'Канал';
}
